import React, { useEffect, useState } from 'react';
import { Table, message, Input, Button } from 'antd';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { editAircraft, getAircrafts } from '../api';
import { AIRCRAFT_TYPES } from '../utils/constants';
import EditAircraftModal from '../components/EditAircraftModal';

const { Search } = Input;

const AircraftsWrapper = styled.div`
	width: 100%;
	height: 100%;
`;

const filterAircrafts = (users: any, searchWord: string) => {
	if (!searchWord) {
		return users;
	}

	return users.filter(
		(a: any) =>
			`${a.registration}`.toLowerCase().includes(searchWord.toLowerCase()) ||
			`${a.model}`.toLowerCase().includes(searchWord.toLowerCase()) ||
			`${a.type_code}`.toLowerCase().includes(searchWord.toLowerCase()) ||
			`${a.engines_data}`.toLowerCase().includes(searchWord.toLowerCase()) ||
			`${a.organization_name}`.toLowerCase().includes(searchWord.toLowerCase()) ||
			`${a.id}`.toLowerCase().includes(searchWord.toLowerCase())
	);
};

function Aircrafts(props: any) {
	const [aircrafts, setAircrafts]: any = useState([]);
	const [searchValue, setSearchValue]: any = useState('');
	const [aircraftModalVisible, toggleAircraftModal]: any = useState(false);
	const [selectedAircraft, setSelectedAircraft]: any = useState({});
	const [loading, setloading]: any = useState(false);
	const [saving, setSaving]: any = useState(false);

	async function fetchAircrafts(silent: boolean = false) {
		if (!silent) {
			setloading(true);
		}

		const resp = await getAircrafts().catch((err) => message.error('Something went wrong, cannot get aircrafts'));
		if (resp && resp.length) {
			setAircrafts(resp);
		}

		setloading(false);
	}

	useEffect(() => {
		fetchAircrafts();
	}, []);

	const onSearch = (ev: any) => setSearchValue(ev.target.value);

	const columns = [
		{
			title: 'ID',
			dataIndex: 'id',
			key: 'id',
		},
		{
			title: 'Registration',
			dataIndex: 'registration',
			key: 'registration',
		},
		{
			title: 'Model',
			dataIndex: 'model',
			key: 'model',
		},
		{
			title: 'Aircraft type',
			dataIndex: 'aircraft_type',
			key: 'aircraft_type',
			render: (text: string) => {
				return AIRCRAFT_TYPES[text as keyof typeof AIRCRAFT_TYPES];
			},
		},
		{
			title: 'Type code',
			dataIndex: 'type_code',
			key: 'type_code',
		},
		{
			title: 'Engine(s) info',
			dataIndex: 'engines_data',
			key: 'engines_data',
		},
		{
			title: 'Organization',
			dataIndex: 'organization_name',
			key: 'organization_name',
		},
		{
			title: '',
			key: 'action',
			width: 100,
			render: (text: string, record: any) => (
				<>
					<Button
						onClick={() => {
							toggleAircraftModal(true);
							setSelectedAircraft(record);
						}}
						type="link"
					>
						Edit
					</Button>
				</>
			),
		},
	];

	async function saveAircraft(data: any) {
		setSaving(true);

		try {
			await editAircraft(selectedAircraft.id, {
				aircraft_type: data.aircraft_type,
			});
			await fetchAircrafts(true);
			toggleAircraftModal(false);
		} catch (err) {
			message.error('Something went wrong, cannot save aircraft');
		}

		setSaving(false);
	}

	return (
		<AircraftsWrapper>
			<Search
				placeholder="Search aircrafts"
				onChange={onSearch}
				style={{ width: 200, marginBottom: 12, float: 'right' }}
			/>
			<Table
				id="main"
				pagination={{
					size: 'default',
					pageSize: 40,
					showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
				}}
				locale={{
					emptyText: 'No aircrafts found',
				}}
				style={{ paddingBottom: 24 }}
				loading={loading}
				rowKey={(record: any) => record.id}
				columns={columns}
				dataSource={filterAircrafts(aircrafts, searchValue)}
			/>
			<EditAircraftModal
				visible={aircraftModalVisible}
				onClose={() => {
					toggleAircraftModal(false);
					setSelectedAircraft({});
				}}
				onSave={saveAircraft}
				saving={saving}
				aircraft={selectedAircraft}
			/>
		</AircraftsWrapper>
	);
}

export default withRouter(Aircrafts);
